// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2s-q";
export var animationRelative = "_2s-p";
export var backdropBlur = "_2s-0";
export var detailLabelCell = "_2s-12";
export var detailTable = "_2s-11";
export var detailValueCell = "_2s-13";
export var docIconBox = "_2s-1d";
export var docIconBoxMd = "_2s-1f";
export var docIconBoxSm = "_2s-1e";
export var docTypeRow = "_2s-16";
export var docTypeRowInner = "_2s-17";
export var dropdownMatchDatePicker = "_2s-3";
export var evidenceCardContent = "_2s-1c";
export var fileUploadSpin = "_2s-j";
export var gorgiasOpenButton = "_2s-15 _2s-d";
export var gorgiasTicketCard = "_2s-14";
export var heroModalFooterButton = "_2s-18";
export var hiddenContainer = "_2s-o";
export var iconPrimary = "_2s-1g";
export var iconSecondary = "_2s-1h";
export var iconTertiary = "_2s-1i";
export var integrationCard = "_2s-1";
export var integrationLogoBox = "_2s-2";
export var mainColumnSticky = "_2s-1b";
export var maxWidthContainer = "_2s-19";
export var modalContentBody = "_2s-a";
export var modalHeaderImage = "_2s-5";
export var modalImageLabel = "_2s-7";
export var modalImageOverlay = "_2s-6";
export var modalImageSubtitle = "_2s-9";
export var modalImageTitle = "_2s-8";
export var modalImageWrapper = "_2s-4";
export var modalStickyFooter = "_2s-b";
export var removeButton = "_2s-e";
export var sidebarColumn = "_2s-1a";
export var spinner = "_2s-i";
export var timelineLine = "_2s-y";
export var timelineLineBlack = "_2s-10 _2s-y";
export var timelineLineGray = "_2s-z _2s-y";
export var timelineLineHeight = "_2s-x";
export var tlDotActivate = "_2s-u";
export var tlDotActivateAnim = "_2s-t";
export var tlDotHide = "_2s-s";
export var tlDotHideAnim = "_2s-r";
export var tlLineActivate = "_2s-w";
export var tlLineActivateAnim = "_2s-v";
export var uploadHint = "_2s-n";
export var uploadIconBox = "_2s-k";
export var uploadLabel = "_2s-m";
export var uploadText = "_2s-l";
export var uploadZone = "_2s-f";
export var uploadZoneCursorDefault = "_2s-h";
export var uploadZoneCursorPointer = "_2s-g";
export var uploadedFileRow = "_2s-c";
export var viewButton = "_2s-d";